import location from './location.svg'
import arrow from './arrow-down.svg'

export const icon = {
  location,
  arrow
}

export default icon
